<template>
	<div>
		<v-alert :type="alert.type" v-show="alert.show">{{alert.type}}</v-alert>
		<revenue-sum-report-filter
			@submit="submit"
			@excelExport="submitExcel"
		/>

		<v-layout align-center justify-center class="dataLoading">
			<v-progress-circular
				class="lodingDataProgressBar"
				indeterminate
				v-show="loadingData"
			/>
		</v-layout>

		<v-card class="revenueSumResults">
			<revenue-sum-report-sums
				class="revenueSumReportSums"
				:showContent="showDataTable"
				:tableContent="revenueSumReportResult"
			/>
			<revenue-sum-report-table
				:revenueSumItems="revenueSumReportResult"
				:loadingData="loadingData"
				v-show="showDataTable"
			/>
		</v-card>
	</div>
</template>
<script>
import axios from 'axios'
import RevenueSumReportFilter from './RevenueSumReportFilter.vue'
import RevenueSumReportTable from './RevenueSumReportTable.vue'
import revenueSumReportSums from './RevenueSumReportSums.vue'

export default {
	components: {
		RevenueSumReportFilter,
		RevenueSumReportTable,
		revenueSumReportSums,
	},
	name: 'RevenueSumReport',
	data() {
		return {
			showDataTable: false,
			loadingData: false,
			revenueSumReportResult: [],
			alert: {
				tyep: 'info',
				message: '',
				show: false,
			},
		}
	},
	methods: {
		async submit(submittedData) {
			this.loadingData = true
			// eslint-disable-next-line no-undef
			const res = await axios.post(`${config.baseAPIurl}/revenue-sum-report`, submittedData)
			this.revenueSumReportResult = res.data
			this.showDataTable = true
			this.loadingData = false
		},
		async submitExcel(submittedData) {
			try {
				this.loadingData = true
				const res = await axios({
					method: 'post',
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/revenue-sum-report/excel`,
					data: submittedData,
					responseType: 'blob'
				})
				this.loadingData = false
				// eslint-disable-next-line no-undef
				saveAs(new Blob([res.data]), 'revenue_sum_report.xlsx')
			} catch (err) {
				this.alert.show = true
				this.alert.message = 'Excel could not be downloaded'
				this.alert.type = 'error'
				// eslint-disable-next-line no-return-assign
				setTimeout(() => this.alert.show = false, 5000)
			} finally {
				this.loadingData = false
			}
		},
	},
}
</script>

<style scoped>
.revenueSumReportSums{
	padding-top: 25px;
}

.dataLoading{
	padding-top: 25px;
	padding-bottom: 25px;
}

.revenueSumResults{
	margin-bottom: 39px;
}
</style>
